//libraries
import _ from 'lodash';

/**
 * Import all constants as an object.
 */
import * as actionType from "../../constants/actionType";


let initialState = {
    clientDetail: {

    },
    redirectClientId:null, 
    dmClientDetail:{}  
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export default function (state, action) {
    state = state || initialState;
    switch (action.type) {
        case actionType.CLIENT_DETAIL_SUCCESS:
            return _.assign({}, state, {
                clientDetail: action.payload.receiveObj,
                redirectClientId:null
            });
        case actionType.CLIENT_DETAIL_FAIL:
            return _.assign({}, state, {
                clientDetail: undefined,
            });
        case actionType.CLIENT_DETAIL_RESET:
            return _.assign({}, state, {
                clientDetail: {},
                redirectClientId:null
            });
            case actionType.CLIENT_REDIRECT:
            return _.assign({}, state, {
                redirectClientId:action.clientId
            });
            case actionType.DM_CLIENT_DETAIL_SUCCESS:
              return _.assign({}, state, {
              dmClientDetail: action.payload.receiveObj, });
        default:
            return state;
    }
}